import { api } from './api';

export const relatorioRomaneioService = {
  imprimirDiferencaRomaneioSaidas: async (idRomaneio: number): Promise<Blob> => {
    const response = await api.get<Blob>(`/api/Romaneio/GetSDiferencaRomaneioSaidasXlsx?idRomaneio=${idRomaneio}`);
    return response.data;
  },

  getItensNaoVendidosPorIdRomaneio: async (idRomaneio: number): Promise<Blob> => {
    const response = await api.get<Blob>(`/api/Romaneio/GetItensNaoVendidosPorIdRomaneio?idRomaneio=${idRomaneio}`);
    return response.data;
  },

  getItensNaoFicaramEmSaida: async (idRomaneio: number): Promise<Blob> => {
    const response = await api.get<Blob>(`/api/Romaneio/GetItensNaoFicaramEmSaida?idRomaneio=${idRomaneio}`);
    return response.data;
  },
};
